import auth from 'auth'
import dayjs from 'dayjs'

export const isLoginExpired = (): boolean => {
  const sevenDaysFromToday = dayjs().utc().add(7, 'day')
  const tokenExpired = auth.getUserInfoFromToken().exp * 1000
  const expiredDate = dayjs(tokenExpired).utc()
  return sevenDaysFromToday >= expiredDate
}



// WEBPACK FOOTER //
// ./src/domains/authentication/loginExpiration.ts